module.exports = __webpack_public_path__ + "static/img/tab-one.c52cb022.png";